import { render, staticRenderFns } from "./integralWithdrawalList.vue?vue&type=template&id=39198c98&"
import script from "./integralWithdrawalList.vue?vue&type=script&lang=js&"
export * from "./integralWithdrawalList.vue?vue&type=script&lang=js&"
import style0 from "./integralWithdrawalList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports